/**
 * Import necessary modules and components from React, React Bootstrap, and react-i18next.
 * @module React
 * @module Card
 * @module Col
 * @module Container
 * @module Row
 * @module useTranslation
 */
import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

/**
 * Import the ConfirmModal component from the specified path.
 * @param {{string}} path - The path to the ConfirmModal component.
 * @returns None
 */
import ConfirmModal from "../../components/confirmModal/confirmModel";
import CustomButton from "../../components/customButton/customButton";

/**
 * A functional component that represents a login form.
 * @param {{object}} props - The component props.
 * @param {{function}} props.closeErrorModal - Function to close the error modal.
 * @param {{function}} props.microsoftLogin - Function to handle Microsoft login.
 * @param {{boolean}} props.showErrorModal - Boolean indicating whether to show the error modal.
 * @param {{boolean}} props.loaderButtonShow - Boolean indicating whether to show the loader button.
 * @param {{string}} props.modalDescription - The description for the error modal.
 * @returns The login form component.
 */
const LoginComponent = (props) => {
  const { t } = useTranslation();
  const CLOUDINARY_URL =
    process.env.REACT_APP_CLOUDNARY_URL +
    process.env.REACT_APP_CLOUDNARY_NAME +
    process.env.REACT_APP_CLOUDNARY_SUBFLODER;

  /**
   * Destructures the `props` object to extract the `closeErrorModal`, `microsoftLogin`,
   * and `showErrorModal` functions.
   * @param {{object}} props - The object containing the functions to destructure.
   * @returns None
   */
  const { closeErrorModal, microsoftLogin, showErrorModal, loaderButtonShow, modalDescription } = props;

  /**
   * Renders a login page with Microsoft authentication.
   * @returns The JSX elements for the login page.
   */
  return (
    <>
      <React.Fragment>
        <div className="auth-pages">
          <div className="Auth_BackImage">
            <img
              src={CLOUDINARY_URL + "Auth_Background.png"}
              alt="Login BackGround"
            />
          </div>
          <Container>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div className="Logo_Auth">
                    <img
                      src={CLOUDINARY_URL + "Logo.png"}
                      alt="Logo.png"
                      className="img-fluid"
                    />
                  </div>
                  <Card.Body className="Card_Body">
                    <div className="Auth-Content">
                      <h1>{t("HELLO")}</h1>
                      <p>
                        {t("SIGN_IN_USING_YOUR_MICROSOFT_ACCOUNT_TO_CONTINUE")}
                      </p>
                      <div className="MicroSoft_Login_Button">
                        <CustomButton
                          type="button"
                          className="btn"
                          onClick={microsoftLogin}
                          loading={loaderButtonShow}
                        >
                          <img
                            src={CLOUDINARY_URL + "Micro_icon.png"}
                            alt="Microsoft_icon"
                          />
                          {t("SIGN_IN_WITH_MICROSOFT")}
                        </CustomButton>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
                <div className="copyRightTextStyle text-center">
                  <p>{t("COPYRIGHT_SCOTRAIL")}</p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>

      {/**
       * Renders a ConfirmModal component with the specified props.
       * @param {{string}} modalTitle - The title of the modal.
       * @param {{string}} modalDescription - The description text of the modal.
       * @param {{boolean}} isUnderline - Indicates whether the description text should be underlined.
       * @param {{string}} messageLink - The email address or contact information to be displayed as a link.
       * @param {{boolean}} showModal - Indicates whether the modal should be shown.
       * @param {{function}} onHide - Callback function to handle the modal close event.
       * @param {{string}} leftBtnTitle - The title of the left button in the modal.
       * @param {{string}} iconColor - The color of
       */}
      <ConfirmModal
        modalTitle={"Error"}
        modalDescription={modalDescription}
        isUnderline={true}
        showModal={showErrorModal}
        onHide={() => closeErrorModal()}
        leftBtnTitle={t("OK")}
        iconColor={"mdi mdi-exit-to-app "}
        iconCricle={"iconCricleDelete"}
        leftBtnClass={"ok_Btn"}
        isFirstButton={true}
        onProcced={async () => {
          closeErrorModal();
        }}
      />
    </>
  );
};

export default LoginComponent;